
import Snackbar from '../components/Snackbar';
export default {
  name: 'DocumentType',
  components: {
    Snackbar
  },
  middleware: 'unauthenticated'
};
